var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 29.6,
    rx: 4.5,
    fill: "#CD2A3F",
    stroke: "#CD2A3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 8.625H24.1956C23.8675 8.625 23.5525 8.75438 23.3181 8.985L21.625 10.655V9.875C21.625 8.83938 20.785 8 19.75 8H7.875C6.84125 8 6 8.84063 6 9.875V14.2325V19.875C6 20.91 6.83938 21.75 7.875 21.75H19.75C20.785 21.75 21.625 20.91 21.625 19.875V19.1119L23.3181 20.7819C23.5525 21.0125 23.8675 21.1419 24.1956 21.1419H24.75C25.44 21.1419 26 20.5825 26 19.8919V9.875C26 9.18437 25.44 8.625 24.75 8.625ZM7.875 20.5C7.53 20.5 7.25 20.2194 7.25 19.875V9.875C7.25 9.52938 7.52938 9.25 7.875 9.25H19.75C20.0944 9.25 20.375 9.53 20.375 9.875V19.875C20.375 20.2194 20.0944 20.5 19.75 20.5H7.875ZM24.75 19.8919H24.1956H24.125L21.625 17.3919V17.375L21 16.75V13L24.125 9.875H24.1956H24.75V19.8919Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveVideoIcon);
export default __webpack_public_path__ + "static/media/activeVideoIcon.b699db99624903c5af7eeed5ec3b37cf.svg";
export { ForwardRef as ReactComponent };